export default __webpack_public_path__ + "static/media/01_photo.de4b4307.jpg";